import script from "./ProfileFocusSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileFocusSection.vue?vue&type=script&setup=true&lang=ts"

import "./ProfileFocusSection.vue?vue&type=style&index=0&id=719b6b7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-719b6b7a"]])

export default __exports__